import * as React from "react";
import type { SVGProps } from "react";
const SvgFileEye01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M11.4 21.6h-6A2.4 2.4 0 0 1 3 19.2V4.8a2.4 2.4 0 0 1 2.4-2.4h10.8a2.4 2.4 0 0 1 2.4 2.4v4.8m-1.8 6.54v-.063m4.2.114s-.996 2.94-4.2 2.888c-3.204-.051-4.2-2.888-4.2-2.888s.956-2.991 4.2-2.991 4.2 2.991 4.2 2.991"
    />
  </svg>
);
export default SvgFileEye01;
